module.exports = __webpack_public_path__ + "img/FGr_Ortung_biologisch.57aa8d67.svg";